import React from 'react';
import { Link } from 'react-router-dom';
import { offer } from '../../utils/data';
import { Button } from '../../styles';
import styled from 'styled-components';

const WhatWeOffer = () => {


    return (
        <>
            <StyledWhatWeOffer>
                <div className="container pry-text">
                    <div className=" text-center ">
                        <h3 className="mb-5 ">
                            What We Offer
                        </h3>
                    </div>

                    <div className="row">
                        {
                            offer.map(({ icon, title, content }, i) =>
                                <div className="col-md-6 mb-4" key={i}>
                                    <div className="card  h-100">
                                        <div className="card-body my-4 py-5 d-flex gap-3">
                                            <div className="">
                                                <p className="display-2  pry light-text p-3 pt-0 br-md">
                                                    {icon}
                                                </p>
                                            </div>
                                            <div className="">
                                                <h6 className="mb-3 fw-bold">
                                                    {title}
                                                </h6>
                                                <p className="text-justify">
                                                    {content}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )
                        }
                    </div>
                </div>
            </StyledWhatWeOffer>

        </>
    );
};

export default WhatWeOffer;


const StyledWhatWeOffer = styled.section`
    
    padding: 4rem 0;


`;